var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "ptc_container"
  }, [_c('div', {
    staticClass: "info_section"
  }, [_c('div', {
    staticClass: "info_txt"
  }, [_c('span', {
    staticClass: "lbtx"
  }, [_vm._v("공정도란?")]), _vm._m(1), _c('hr', {
    staticClass: "hr_line"
  }), _c('p', {
    staticClass: "txt_typ_3"
  }, [_vm._v("공정도는 재료(Material), 공정(Process), 측정(Measurement) 및 분석(Analysis)의 단위로 소재가 만들어지는 과정을 표현합니다.")]), _c('p', {
    staticClass: "txt_typ_3"
  }, [_vm._v("측정 및 분석은 소자/소재가 만들어지는 이력의 메타정보를 기반으로 하기때문에, 공정도는 측정분석 프로토콜을 이해하는 데 있어서 꼭 필요한 안내판입니다")]), _c('a', {
    staticClass: "info_txt_btn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v("공정도 만들어 보기")])]), _vm._m(2)]), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6)]), _c('div', {
    staticClass: "btm_banner"
  }, [_c('div', {
    staticClass: "btm_banner_inner"
  }, [_c('p', [_vm._v("효율적인 연구를 하기위한 공정도를 만들어보세요.")]), _c('a', {
    staticClass: "linkbtn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v("공정도 만들어 보기")])])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sub_top"
  }, [_c('div', {
    staticClass: "sub_tit"
  }, [_c('div', {
    staticClass: "sub_tit_inner"
  }, [_c('h2', [_vm._v("공정도")])])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "txt_typ_lg"
  }, [_c('span', {
    staticClass: "txt_ib"
  }, [_vm._v("소재가 만들어지는")]), _c('span', {
    staticClass: "txt_ib"
  }, [_vm._v("과정을 표현한 순서도")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info_graphic"
  }, [_c('div', {
    staticClass: "info_graphic_img"
  }, [_c('img', {
    attrs: {
      "src": require("@/style/new/images/info/processchart_01.png"),
      "alt": ""
    }
  })])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info_section"
  }, [_c('div', {
    staticClass: "info_txt"
  }, [_c('span', {
    staticClass: "lbtx"
  }, [_vm._v("CheckPoint 01")]), _c('p', {
    staticClass: "txt_typ_md"
  }, [_vm._v("복잡한 소재 제작 과정을 직관적으로 알 수 있습니다.")])]), _c('div', {
    staticClass: "info_graphic"
  }, [_c('div', {
    staticClass: "info_graphic_img"
  }, [_c('img', {
    attrs: {
      "src": require("@/style/new/images/info/processchart_02.png"),
      "alt": ""
    }
  })])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info_section"
  }, [_c('div', {
    staticClass: "info_txt"
  }, [_c('span', {
    staticClass: "lbtx"
  }, [_vm._v("CheckPoint 02")]), _c('p', {
    staticClass: "txt_typ_md"
  }, [_vm._v("나만의 연구 과정을 쉽게 정리하고 설명할 수 있습니다.")])]), _c('div', {
    staticClass: "info_graphic"
  }, [_c('div', {
    staticClass: "info_graphic_img"
  }, [_c('img', {
    attrs: {
      "src": require("@/style/new/images/info/processchart_03.png"),
      "alt": ""
    }
  })])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info_section"
  }, [_c('div', {
    staticClass: "info_txt"
  }, [_c('span', {
    staticClass: "lbtx"
  }, [_vm._v("CheckPoint 03")]), _c('p', {
    staticClass: "txt_typ_md"
  }, [_vm._v("전문가들이 실험 방법을 검증하고 공개해줍니다.")])]), _c('div', {
    staticClass: "info_graphic"
  }, [_c('div', {
    staticClass: "info_graphic_img"
  }, [_c('img', {
    attrs: {
      "src": require("@/style/new/images/info/processchart_03.png"),
      "alt": ""
    }
  })])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info_section"
  }, [_c('div', {
    staticClass: "info_txt"
  }, [_c('span', {
    staticClass: "lbtx"
  }, [_vm._v("CheckPoint 04")]), _c('p', {
    staticClass: "txt_typ_md"
  }, [_vm._v("전문가들이 검증한 소재 제작 정보를 검색을 통해 손쉽게 획득할 수 있습니다.")])]), _c('div', {
    staticClass: "info_graphic"
  }, [_c('div', {
    staticClass: "info_graphic_img"
  }, [_c('img', {
    attrs: {
      "src": require("@/style/new/images/info/processchart_03.png"),
      "alt": ""
    }
  })]), _c('p', {
    staticClass: "desc_txt typ1"
  }, [_vm._v("프로토콜 플랫폼은 복잡한 소재 제작과정을 쉽고 편리하게 제작할 수 있는 공정도 편집기능을 제공하여, 나만의 연구 과정을 쉽게 정리 할 수 있습니다.")]), _c('p', {
    staticClass: "desc_txt typ2"
  }, [_vm._v("또한 전문가들이 "), _c('span', {
    staticClass: "colr"
  }, [_vm._v("검증하고 공개한 다양한 공정들을 검색하고 활용")]), _vm._v("할 수 있어, 더욱 효율적인 연구를 할 수 있도록 도와줍니다.")])])]);

}]

export { render, staticRenderFns }